// reducers/index.js
import { combineReducers } from 'redux';
import dataFileReducer from './dataFileReducer'; 
import authReducer from './authReducer';
import blogReducer from './blogReducer'; // new blog reducer
import { cartReducer } from './cartReducer';
import { orderReducer } from './orderReducer';

const rootReducer = combineReducers({
  api: dataFileReducer,
  auth: authReducer,
  blogs: blogReducer,
  cart: cartReducer,
  orders: orderReducer
});

export default rootReducer;
